<template>
  <div class="movies-overview-area">
    <div class="container">
      <div
        class="movies-overview-inner"
        :style="{ backgroundImage: `url(${backgroundImage})` }"
      >
        <div class="movies-overview-content">
          <h2 class="text-white">ابدأ تجربتك المجانية اليوم واكتشف الفرق بنفسك</h2>
          <!-- تحويل الرابط إلى واتساب مباشر للحفاظ على استقرار الكود وسرعة تواصل العميل -->
          <a href="https://wa.me/447429916178" target="_blank" class="btn">
            <span class="border-style">اشترك الآن</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SubscribeNow",
  data() {
    return {
      backgroundImage: require("@/assets/images/movie-home/overview-bg.jpg"),
    };
  },
});
</script>